export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
}

export enum ReviewSortBy {
  CREATED_AT = 'createdAt',
  LIKE_COUNT = 'likeCount',
  COST = 'cost',
}

export interface ReviewListFilterValues {
  minRating?: number;
  maxRating?: number;
  startDate?: string;
  endDate?: string;
  locationLat?: number;
  locationLng?: number;
  radiusInKm?: number;
  placeId?: string;
  minCost?: number;
  maxCost?: number;
  foodId?: number;
  userId?: string;
  sortBy?: ReviewSortBy;
  sortOrder?: SortOrder;
}
